export const levee = {
  name: `levee`,
  sql: `
    SELECT * FROM solano_lev
    WHERE haz_lev IN ('Yes')
    `,
  cartoCSS: `
    #layer {
      polygon-fill: ramp([haz_lev], (#9ad689), ("Yes"), =);
      polygon-opacity: 0.58;
      polygon-comp-op: overlay;
    }
    #layer::outline {
      line-width: 1;
      line-color: #FFF;
      line-opacity: 0.5;
    }
  `,
}